var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45 24-3.95-3.95A7 7 0 0 0 36.1 18H10a4 4 0 0 0-4 4v52a4 4 0 0 0 4 4h76a4 4 0 0 0 4-4V28a4 4 0 0 0-4-4H45z",
    fill: "#FFB900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m45 24-3.95 3.95A7 7 0 0 1 36.1 30H6v44a4 4 0 0 0 4 4h76a4 4 0 0 0 4-4V28a4 4 0 0 0-4-4H45z",
    fill: "#FFD75E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m45 24-3.95 3.95A7 7 0 0 1 36.1 30H6v44a4 4 0 0 0 4 4h76a4 4 0 0 0 4-4V28a4 4 0 0 0-4-4H45z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 78h76c1.309 0 2.47-.628 3.2-1.6l-.355.178a3.996 3.996 0 0 1-1.79.422H8.948c-.62 0-1.23-.144-1.785-.42l-.364-.182A3.994 3.994 0 0 0 9.999 78z",
    fill: "#BF5712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.697 28.803 46.5 24H45l-3.95 3.95A7 7 0 0 1 36.1 30H6v1h30.393a7.5 7.5 0 0 0 5.304-2.197z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 6,
    y1: 24,
    x2: 6,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FFD75E",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.792d76c7cfbcc905865fd5929c14d86e.svg";
export { ForwardRef as ReactComponent };